export enum ChangelogServiceCode {
  CentralHub = 'CENTRAL_HUB',
  Platform = 'PLATFORM',
}
